module.exports = __webpack_public_path__ + "static/article-image-first-56c68048a2b9c0be3bcc0a29a5778bc2.png";